<template>
  <div>
    <div class="press-releases">
      <h2
        v-if="isMobile && !hasUrgentPressReleases"
        class="h2 title">
        {{ translate('prLatestNews') }}
      </h2>
      <div v-for="(item, key, index) in data" :key="index" class="monthyear-container">
        <h2 class="group-title"> {{ key }} </h2>
        <PressRelease
          v-for="(pressRelease, index) in item.entries"
          :key="index"
          :isMobile="isMobile"
          :hasSeparator="!(index === item.entries.length - 1)"
          :pressRelease="pressRelease"/>
      </div>
    </div>
  </div>
</template>

<script>
import PressRelease from '@/components/PressRelease'
import { hasUrgentPressReleases } from '@/infrastructure/Configuration'
import { translate } from 'rhg-vue-common'

export default {
  name: 'PressReleases',
  components: {
    PressRelease
  },
  props: {
    data: {
      type: [Object, Array]
    },
    isMobile: Boolean
  },
  data: () => {
    return {
      hasUrgentPressReleases: false
    }
  },

  mounted () {
    this.hasUrgentPressReleases = hasUrgentPressReleases
  },
  methods: {
    translate
  }
}
</script>

<style lang="scss" scoped>
  .press-releases {
    display: flex;
    flex-direction: column;
    text-align: left;

    .monthyear-container {
      display: flex;
      flex-direction: column;
    }
  }

  .title {
    font-size: 11px;
    text-transform: uppercase;
    color: #494949;
    font-weight: 700;
    &.h2 {
      text-align: left;
      padding-bottom: 0px;
      margin-bottom: 0px;
      &:before {
        display: none;
      }
    }
  }

  .group-title {
    font-size: 26px;
    font-weight: 700;
    margin: 28px 0;
    margin-bottom: 8px;
  }

</style>
